import { AMOUNT_OF_COLUMNS_DESKTOP } from './MasonryAccordionLinks.constants';
import { ACCORDION_REVEAL_ANIMATION_DURATION } from '../PopupContent/PopupContent.constants';
export function getDelay(index, isDesktop) {
  if (!isDesktop) {
    return 0;
  }
  return index % AMOUNT_OF_COLUMNS_DESKTOP * ACCORDION_REVEAL_ANIMATION_DURATION / AMOUNT_OF_COLUMNS_DESKTOP;
}